// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import { FulfillmentMethod } from "@insite/client-framework/Services/SessionService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

/**
 * Xng-Change
 * PAC-1193
 * remove shipping and carriers from expand for PickUp
 * read from window localStorage as state session will not be updated yet
 */
export const XngPopulateApiParameter: any = (props: any) => {
    const sessionFulfillmentMethod = window?.localStorage?.getItem("sessionFulfillmentMethod");
    if (sessionFulfillmentMethod === FulfillmentMethod.PickUp) {
        props.apiParameter.expand = props.apiParameter.expand?.filter((expand: string) => expand !== "shipping" && expand !== "carriers");
    }
    props.apiParameter.expand?.push("validation");
    props.apiParameter.expand = [...new Set(props.apiParameter.expand.concat(["cartLines", "restrictions", "paymentOptions"]))];
};

addToChainAfter(chain, PopulateApiParameter, XngPopulateApiParameter);
